/**
 * @author varun
 */
angular.module('jv.jobseeker.playbackVideo', [])

.controller('VideoPlaybackCtrl', ['$scope', 'videoService', 'formResponseIdService', 'dataService', '$location', '$window', '$jobviteUrls', '$timeout', '$log', '$rootScope',
    function($scope, videoService, formResponseIdService, dataService, $location, $window, $jobviteUrls, $timeout, $log, $rootScope) {

        var interviewId = $location.search().interviewId || $location.path().split('/')[3];
        $scope.type = $location.search().type || $location.path().split('/')[2]; //type -> 'actualInterview', 'practiceInterview'
        $scope.actualId = dataService.getActualId();

        $scope.practiceInterviewId = interviewId;
        $scope.answersInfo = null;
        $scope.summary = null;
        $scope.parent = {};
        $scope.hidePrevious = true;
        //default values
        $scope.parent.selectedVideo = null;
        $scope.parent.index = 0;
        $scope.parent.question = "";
        $scope.vonageRecording = dataService.getSessionData(interviewId);
        if($scope.vonageRecording!==null) {
            $scope.vonageRecording = $scope.vonageRecording === 'true';
            $scope.actualId = dataService.getSessionData(interviewId+'-actualId');
        } else {
            videoService.isVonageEnabled({
                'formResponseId': interviewId
            }, function (result) {
            if (angular.isDefined(result)) {
                $scope.vonageRecording = result.isVonage;
                $scope.showPlayVideo = false;
            }
        });
        }
        $scope.retryForPI = 3;
        $scope.timeoutsForPI = [20000, 15000, 10000];
        $scope.retriesForPIDone = false;
        formResponseIdService.setId(interviewId);
        videoService.getAnswerSummary(null, function(result) {
        $scope.setAnswersInfo(result);
        if($scope.type === 'practiceInterview'){
            if($scope.areVideosUploaded(result.bean.answers)){
                $scope.retriesForPIDone = true;
            }else{
                $scope.pollForPracticeAnswers();
            }
        }
        });

        $scope.isMobileDevice = /Mobi/i.test(window.navigator.userAgent);

        $scope.showPlayVideoToggle = function(value) {
            $scope.showPlayVideo = value;
        }

        $scope.areVideosUploaded = function(answers){
            if(!angular.isArray(answers)){
                return false;
            }
            for(var i=0; i< answers.length; i++){
                if(answers[i].videoUrls == null){
                    return false
                }
            }
            return true;
        };

        $scope.pollForPracticeAnswers = function(){
            if($scope.retryForPI >= 0 && !$scope.retriesForPIDone){
                --$scope.retryForPI;
                $timeout(function(){
                    videoService.getAnswerSummary(null, function(result){
                        if($scope.areVideosUploaded(result.bean.answers)){
                            $scope.setAnswersInfo(result);
                            $scope.retriesForPIDone = true;
                        }else{
                            $scope.pollForPracticeAnswers();
                        }
                    });
                }, $scope.timeoutsForPI[$scope.retryForPI]);
            }
            if($scope.retryForPI == -1 && !$scope.retriesForPIDone){
                $log.error("Not able to fetch the practice videos for {0}".format(formResponseIdService.getId()));
            }
        };

        $scope.setAnswersInfo = function(result){
            $scope.answersInfo = result.bean;
            //Used only for Practice Interview
            $scope.parent.actualReview = false;
            $scope.parent.selectedVideo = $scope.answersInfo.answers[0].videoId;
            $scope.parent.selectedVideoUrls = $scope.answersInfo.answers[0].videoUrls;
            $scope.parent.index = 1;
            $scope.parent.question = $scope.answersInfo.answers[0].question.title;
        };

        videoService.getSummary(null, function(result) {
            $scope.summary = result;
            //since the directive is common-footer, which doesn't fall in this controller
            //adding privacyPolicyURL to the rootScope
            if(result.privacyPolicyURL){
                $rootScope.privacyPolicyURL=result.privacyPolicyURL;
            }
        });

        $scope.getPracticeInterview = function() {
            dataService.setSessionData('isRetakePracticeInterview', true);
            videoService.getPracticeInterview(null, function(response) {
                if (angular.isDefined(response.bean.SId)) {
                    //TODO-PRANAV: Need to ask Ken if we need to go to setup screen again or not.
                    if (angular.isDefined($scope.actualId) && $scope.actualId !== null) {
                        $location.path('Interview/Setup/practiceInterview/' + response.bean.SId + "/" + $scope.actualId);
                    } else {
                        $location.path('Interview/Setup/practiceInterview/' + response.bean.SId);
                    }
                }
            });
            return false;
        };

        $scope.startActualInterview = function() {
            dataService.setSessionData('isActualInterviewStarted', true);
            dataService.setActualId(null);
            $location.path("/Interview/recordInterview/" + $scope.actualId);
        };

        $scope.totalQArray = function() {
            if ($scope.answersInfo) {
                return new Array($scope.answersInfo.answers.length);
            } else {
                return null;
            }
        };

        $scope.isCurrentAnswer = function(i) {
            if (i == $scope.parent.index) {
                return true;
            } else {
                return false;
            }
        };

        $scope.unaswered = function(i) {
            if (i != $scope.parent.index) {
                return true;
            } else {
                return false;
            }
        };

        $scope.getPrevAnswer = function() {
            if ($scope.parent.index === 1) {
                return;
            }
            var quesIndex = $scope.parent.index - 1;
            $scope.parent.index = quesIndex;
            $scope.parent.actualReview = true;
            $scope.parent.selectedVideoUrls = $scope.answersInfo.answers[quesIndex - 1].videoUrls;
            $scope.parent.selectedVideo = $scope.answersInfo.answers[quesIndex - 1].videoId;
            $scope.parent.question = $scope.answersInfo.answers[quesIndex - 1].question.title;
        };

        $scope.getNextAnswer = function() {
            if ($scope.parent.index === $scope.answersInfo.answers.length) {
                return;
            }
            var quesIndex = $scope.parent.index + 1;
            $scope.parent.index = quesIndex;
            $scope.parent.actualReview = true;
            $scope.parent.selectedVideoUrls = $scope.answersInfo.answers[quesIndex - 1].videoUrls;
            $scope.parent.selectedVideo = $scope.answersInfo.answers[quesIndex - 1].videoId;
            $scope.parent.question = $scope.answersInfo.answers[quesIndex - 1].question.title;
        };
    }
])
    .directive('scrollVideo', function() {
        return {
            restrict: 'A',
            link: {
                post: function(scope, iElement, iAttrs) {
                    function Slider(container) {
                        this.container = container;

                        this.divs = this.container.find('li');
                        this.divWidth = this.divs.width(); //Width of each div
                        this.divsLen = this.divs.length;

                        this.current = 0;
                    }

                    Slider.prototype.transition = function(speed) {
                        this.container.animate({
                            'margin-left': -(this.current * this.divWidth * 3)
                        }, speed);
                    };

                    Slider.prototype.setCurrent = function(dir) {
                        var pos = this.current;

                        pos += (~~(dir === 'next') || -1);
                        this.current = (pos < 0) ? (this.divsLen / 3) - 1 : pos % (this.divsLen / 3);

                        if (this.current === 0) {
                            scope.hidePrevious = true;
                        } else {
                            scope.hidePrevious = false;
                        }

                        if (this.divsLen / 3 < this.current + 1) {
                            scope.hideNext = true;
                        } else {
                            scope.hideNext = false;
                        }

                        return pos;
                    };

                    scope.$watch('answersInfo.answers', function(newVal) {
                        if (angular.isUndefined(newVal) || newVal === null) {
                            return;
                        } else {
                            var container = $('.carouselWrapper').children('.jv-answerList');
                            var slider = new Slider(container);

                            if (scope.answersInfo.answers.length > 3) {
                                scope.hideNext = false;
                            }

                            scope.prevClick = function() {
                                if (slider.current === 0) {
                                    scope.hidePrevious = true;
                                    return;
                                } else {
                                    scope.hidePrevious = false;
                                    slider.setCurrent('prev');
                                    slider.transition(1000);
                                }
                            };

                            scope.nextClick = function() {
                                if (slider.current !== 0) {
                                    scope.hidePrevious = false;
                                } else {
                                    scope.hidePrevious = true;
                                }
                                slider.setCurrent('next');
                                slider.transition(1000);
                            };
                        }
                    });
                }
            }
        };
    });
